module.exports = __webpack_public_path__ + "static/slider-1-1-12d0f14815d5eb1a48394ec334b7c6bc.webp";